export enum SkillExperienceEndpoints {
  FetchSkillExperiences = '/skillexperiences',
}
